export default "__VITE_ASSET__ByKQjjPw__"